import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Nav,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  CardHeader,
  Input,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getReports,
  addFilter,
  getSubscription,
} from "../../redux/reducers/seller";
import axios from "../../config/axios";
import classnames from "classnames";
import "./Reporting.css";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import FreemiumPage from "../Seller/CustomPages/FreemiumPage";

const Reporting = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { translationState } = useSelector((state) => state.user);
  const { userLanguage, token: authToken } = useSelector((state) => state.auth);
  const reportingTranslation =
    translationState?.[0]?.translations?.reporting?.[userLanguage];
  const { filters, reports, loading } = useSelector((state) => state.seller);
  const { value: PageNo } = filters.find((item) => item.field === "pageNo");
  const [activeTab, setActiveTab] = useState("customer");
  const [overviewPreset, setOverviewPreset] = useState("last_7d");
  const [overviewLoading, setOverviewLoading] = useState(false);
  const [overview, setOverview] = useState(null);
  const formatChannelLabel = (value) => {
    const map = {
      paid_social: "Paid Social",
      organic_social: "Organic Social",
      paid_search: "Paid Search",
      organic_search: "Organic Search",
      email: "Email",
      referral: "Referral",
      direct: "Direct",
      other: "Other",
    };
    return map[value] || value || "Other";
  };
  const formatSourceLabel = (value) => {
    if (!value) return "direct";
    return String(value)
      .replace(/_/g, " ")
      .replace(/\b\w/g, (m) => m.toUpperCase());
  };
  const percent = (part, total) => {
    if (!total) return "0.00%";
    return `${((Number(part || 0) / Number(total || 0)) * 100).toFixed(2)}%`;
  };
  const fremiumText1 = `${
    reportingTranslation?.infoLineOne
      ? reportingTranslation?.infoLineOne
      : "Only SOLO and Partner users can use the Sale Reports feature. Please upgrade your membership to access this and many more exciting features."
  }`;
  const { singleSubscription, loading: Membershiploading } = useSelector(
    (state) => state.seller
  );
  useEffect(() => {
    dispatch(getSubscription());
  }, []);
  useEffect(() => {
    dispatch(
      addFilter({
        field: "type",
        value: "customer",
      })
    );
    dispatch(getReports());
  }, []);
  const loadOverview = async () => {
    if (!authToken) return;
    setOverviewLoading(true);
    try {
      const response = await axios.get(
        `/reports/overview?date_preset=${encodeURIComponent(overviewPreset)}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setOverview(response?.data?.data || null);
    } catch (err) {
      setOverview(null);
    } finally {
      setOverviewLoading(false);
    }
  };
  useEffect(() => {
    loadOverview();
  }, [authToken, overviewPreset]);
  let state = {
    activeTab: "1",
    customer_reports: [],
    country_reports: [],
    pagecount1: 1,
    pagecount2: 1,
    nextPage: 2,
    prevPage: 0,
    disablePrevButton1: true,
    disableNextButton1: false,
    disablePrevButton2: true,
    disableNextButton2: false,
    membershipFlag: false,
  };

  const generateCustomerwise = () => {
    var doc = new jsPDF("p", "pt");
    doc.text(180, 50, "YINN Sales Report Customerwise!");
    var res = doc.autoTableHtmlToJson(document.getElementById("table-to-xls"));
    doc.autoTable(res.columns, res.data, { margin: { top: 80 } });
    var header = function (data) {
      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.setFontStyle("normal");
      doc.text("Testing Report", data.settings.margin.left, 50);
    };
    doc.save("SalesReport.pdf");
  };

  const generateCountrywise = () => {
    var doc = new jsPDF("p", "pt");
    doc.text(180, 50, "YINN Sales Report Countrywise!");
    var res = doc.autoTableHtmlToJson(document.getElementById("table-to-xls1"));
    doc.autoTable(res.columns, res.data, { margin: { top: 80 } });
    var header = function (data) {
      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.setFontStyle("normal");
      doc.text("Testing Report", data.settings.margin.left, 50);
    };
    doc.save("SalesReport.pdf");
  };

  const changeReportType = (type) => {
    setActiveTab(type);
    dispatch(
      addFilter({
        field: "type",
        value: type,
      })
    );
    dispatch(getReports());
  };

  const paginate = (pageNo) => {
    if (pageNo > 0) {
      dispatch(
        addFilter({
          field: "pageNo",
          value: pageNo,
        })
      );
      dispatch(getReports());
    }
  };
  return (
    <div className="animated fadeIn" style={{ marginTop: "20px" }}>
      {Membershiploading ? (
        <div className="mt-5" style={{ textAlign: "center" }}>
          <i
            className="fas fa-spinner fa-pulse fa-2x"
            style={{ color: "green" }}
          ></i>
        </div>
      ) : singleSubscription?.membershipType !== "Fremium" ? (
        <Row>
          <Col xs="12" md="12" className="mb-4">
            <Card className="mb-3">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <b>Seller Overview Dashboard</b>
                <div className="d-flex align-items-center">
                  <Input
                    type="select"
                    value={overviewPreset}
                    onChange={(e) => setOverviewPreset(e.target.value)}
                    style={{ width: 180 }}
                    className="mr-2"
                  >
                    <option value="last_7d">Last 7 days</option>
                    <option value="last_14d">Last 14 days</option>
                    <option value="last_30d">Last 30 days</option>
                  </Input>
                  <Button size="sm" color="secondary" onClick={loadOverview} disabled={overviewLoading}>
                    {overviewLoading ? "Refreshing..." : "Refresh"}
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                {overviewLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <i className="fas fa-spinner fa-pulse fa-2x" style={{ color: "green" }}></i>
                  </div>
                ) : overview ? (
                  <>
                    <Row className="mb-3">
                      <Col md="2"><Card body><b>Sales</b><div>${Number(overview?.commerce?.grossSales || 0).toFixed(2)}</div></Card></Col>
                      <Col md="2"><Card body><b>Orders</b><div>{overview?.commerce?.totalOrders || 0}</div></Card></Col>
                      <Col md="2"><Card body><b>Buyers</b><div>{overview?.commerce?.uniqueBuyers || 0}</div></Card></Col>
                      <Col md="2"><Card body><b>Products</b><div>{overview?.catalog?.totalProducts || 0}</div></Card></Col>
                      <Col md="2"><Card body><b>Digital</b><div>{overview?.catalog?.digitalProducts || 0}</div></Card></Col>
                      <Col md="2"><Card body><b>Physical</b><div>{overview?.catalog?.physicalProducts || 0}</div></Card></Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="2"><Card body><b>Meta Impressions</b><div>{Number(overview?.marketing?.meta?.impressions || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Meta Reach</b><div>{Number(overview?.marketing?.meta?.reach || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Meta Clicks</b><div>{Number(overview?.marketing?.meta?.clicks || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Meta Spend</b><div>${Number(overview?.marketing?.meta?.spend || 0).toFixed(2)}</div></Card></Col>
                      <Col md="2"><Card body><b>Meta Results</b><div>{Number(overview?.marketing?.meta?.results || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Meta Accounts</b><div>{overview?.marketing?.meta?.fetchedAccounts || 0}/{overview?.marketing?.meta?.connectedAccounts || 0}</div></Card></Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="2"><Card body><b>Page Views</b><div>{Number(overview?.traffic?.pageViews || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Visitors</b><div>{Number(overview?.traffic?.uniqueVisitors || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>New Visitors</b><div>{Number(overview?.traffic?.newVisitors || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Returning</b><div>{Number(overview?.traffic?.returningVisitors || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Sessions</b><div>{Number(overview?.traffic?.sessions || 0).toLocaleString()}</div></Card></Col>
                      <Col md="2"><Card body><b>Bounce Rate</b><div>{Number(overview?.traffic?.bounceRate || 0).toFixed(2)}%</div></Card></Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Card body>
                          <b>Top products (period)</b>
                          <Table bordered striped responsive size="sm" className="mt-2 mb-0">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>Type</th>
                                <th>Qty Sold</th>
                                <th>Revenue</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(overview?.topProducts || []).length > 0 ? (
                                overview.topProducts.map((item) => (
                                  <tr key={item._id}>
                                    <td>{item.name}</td>
                                    <td>{item.productType === "digital" ? `digital${item.digitalType ? ` (${item.digitalType})` : ""}` : "physical"}</td>
                                    <td>{item.qtySold}</td>
                                    <td>${Number(item.revenue || 0).toFixed(2)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center text-muted">No product sales in this period.</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col md="6">
                        <Card body>
                          <b>Top traffic sources</b>
                          <Table bordered striped responsive size="sm" className="mt-2 mb-0">
                            <thead>
                              <tr>
                                <th>Source</th>
                                <th>Views</th>
                                <th>Share</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(overview?.traffic?.topSources || []).length > 0 ? (
                                overview.traffic.topSources.map((item, index) => (
                                  <tr key={`${item._id}-${index}`}>
                                    <td>{formatSourceLabel(item._id || "direct")}</td>
                                    <td>{Number(item.views || 0).toLocaleString()}</td>
                                    <td>{percent(item.views, overview?.traffic?.pageViews)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr><td colSpan="3" className="text-center text-muted">No tracked data yet.</td></tr>
                              )}
                            </tbody>
                          </Table>
                        </Card>
                      </Col>
                      <Col md="6">
                        <Card body>
                          <b>Channel breakdown</b>
                          <Table bordered striped responsive size="sm" className="mt-2 mb-0">
                            <thead>
                              <tr>
                                <th>Channel</th>
                                <th>Views</th>
                                <th>Share</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(overview?.traffic?.channelBreakdown || []).length > 0 ? (
                                overview.traffic.channelBreakdown.map((item, index) => (
                                  <tr key={`${item._id}-${index}`}>
                                    <td>{formatChannelLabel(item._id || "other")}</td>
                                    <td>{Number(item.views || 0).toLocaleString()}</td>
                                    <td>{percent(item.views, overview?.traffic?.pageViews)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr><td colSpan="3" className="text-center text-muted">No tracked data yet.</td></tr>
                              )}
                            </tbody>
                          </Table>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col md="6">
                        <Card body>
                          <b>Top exit pages</b>
                          <Table bordered striped responsive size="sm" className="mt-2 mb-0">
                            <thead>
                              <tr>
                                <th>Page</th>
                                <th>Exits</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(overview?.traffic?.exitPages || []).length > 0 ? (
                                overview.traffic.exitPages.map((item, index) => (
                                  <tr key={`${item.page}-${index}`}>
                                    <td>{item.page}</td>
                                    <td>{Number(item.exits || 0).toLocaleString()}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr><td colSpan="2" className="text-center text-muted">No tracked data yet.</td></tr>
                              )}
                            </tbody>
                          </Table>
                        </Card>
                      </Col>
                      <Col md="6">
                        <Card body>
                          <b>Country breakdown</b>
                          <Table bordered striped responsive size="sm" className="mt-2 mb-0">
                            <thead>
                              <tr>
                                <th>Country</th>
                                <th>Views</th>
                                <th>Share</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(overview?.traffic?.countryBreakdown || []).length > 0 ? (
                                overview.traffic.countryBreakdown.map((item, index) => (
                                  <tr key={`${item._id}-${index}`}>
                                    <td>{item._id || "unknown"}</td>
                                    <td>{Number(item.views || 0).toLocaleString()}</td>
                                    <td>{percent(item.views, overview?.traffic?.pageViews)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr><td colSpan="3" className="text-center text-muted">No tracked data yet.</td></tr>
                              )}
                            </tbody>
                          </Table>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md="12">
                        <small className="text-muted">
                          Not available without website tracking setup: {(overview?.unavailableWithoutTracking || []).join(", ")}.
                        </small>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="text-muted">Unable to load overview right now.</div>
                )}
              </CardBody>
            </Card>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "customer" })}
                  onClick={() => {
                    changeReportType("customer");
                  }}
                >
                  <b style={{ color: "black" }}>
                    {reportingTranslation?.headingOne
                      ? reportingTranslation?.headingOne
                      : "Sales Report Customerswise"}
                  </b>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "country" })}
                  onClick={() => {
                    changeReportType("country");
                  }}
                >
                  <b style={{ color: "black" }}>
                    {reportingTranslation?.headingTwo
                      ? reportingTranslation?.headingTwo
                      : "Sales Report Countrywise"}
                  </b>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="customer">
                <Row>
                  <Col xs="12" sm="12" md="12">
                    <Card>
                      <CardHeader>
                        <div className="d-flex justify-content-end">
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button"
                            table="table-to-xls"
                            filename="csv file"
                            sheet="sheet1"
                            buttonText="CSV"
                          />
                        </div>
                      </CardHeader>
                      <div>
                        <Row>
                          <div className="col-12 px-md-5 py-md-4 p-3 ">
                            <Table
                              hover
                              bordered
                              striped
                              responsive
                              size="sm"
                              border="1"
                              id="table-to-xls"
                            >
                              <thead align="center">
                                <tr className="header-color">
                                  <th>
                                    {reportingTranslation?.customerName
                                      ? reportingTranslation?.customerName
                                      : "Customer Name"}
                                  </th>
                                  <th>
                                    {reportingTranslation?.customerEmail
                                      ? reportingTranslation?.customerEmail
                                      : "Customer Email"}
                                  </th>
                                  <th>
                                    {reportingTranslation?.placeOrder
                                      ? reportingTranslation?.placeOrder
                                      : "Orders Placed"}
                                  </th>
                                  <th>
                                    {reportingTranslation?.totalSale
                                      ? reportingTranslation?.totalSale
                                      : "Total Sales"}
                                  </th>
                                </tr>
                              </thead>
                              {reports?.length > 0
                                ? reports?.map((report, index) => (
                                    <tbody>
                                      {loading ? (
                                        <td colSpan="4" className="py-5">
                                          <div style={{ textAlign: "center" }}>
                                            <i
                                              className="fas fa-spinner fa-pulse fa-2x"
                                              style={{ color: "green" }}
                                            ></i>
                                          </div>
                                        </td>
                                      ) : report?.usersdetail?.length > 0 &&
                                        !loading ? (
                                        report?.usersdetail?.map(
                                          (userdetail, index) => (
                                            <tr>
                                              <td>
                                                {`${userdetail.firstname} ${userdetail.lastname}`}
                                              </td>
                                              <td> {userdetail.email} </td>
                                              <td align="center">
                                                {report.orderCount}
                                              </td>
                                              <td align="center">
                                                {report.totalSales}
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </tbody>
                                  ))
                                : ""}
                            </Table>
                          </div>
                        </Row>
                      </div>
                    </Card>
                  </Col>
                  <Pagination>
                    <PaginationItem>
                      <PaginationLink
                        onClick={(e) => paginate(PageNo - 1)}
                        style={{ backgroundColor: "rgb(228, 231, 234)" }}
                      >
                        {reportingTranslation?.previousButton
                          ? reportingTranslation?.previousButton
                          : "Prev"}
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        onClick={(e) => paginate(PageNo + 1)}
                        style={{ backgroundColor: "rgb(228, 231, 234)" }}
                        className="mx-2"
                      >
                        {reportingTranslation?.nextButton
                          ? reportingTranslation?.nextButton
                          : "Next"}
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Row>
              </TabPane>
              <TabPane tabId="country">
                <Row>
                  <Col xs="12" sm="12" md="12">
                    <Card>
                      <CardHeader>
                        <div className="d-flex justify-content-end">
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button"
                            table="table-to-xls1"
                            filename="csv file"
                            sheet="sheet1"
                            buttonText="CSV"
                          />
                        </div>
                      </CardHeader>
                      <div>
                        <Row>
                          <div className="col-12 px-md-5 py-md-4 p-3 ">
                            <Table
                              hover
                              bordered
                              striped
                              responsive
                              size="sm"
                              border="1"
                              id="table-to-xls1"
                            >
                              <thead align="center">
                                <tr className="header-color">
                                  <th>
                                    {reportingTranslation?.billing
                                      ? reportingTranslation?.billing
                                      : "Billing Country"}
                                  </th>
                                  <th>
                                    {reportingTranslation?.placeOrder
                                      ? reportingTranslation?.placeOrder
                                      : "Orders Placed"}
                                  </th>
                                  <th>
                                    {reportingTranslation?.totalSale
                                      ? reportingTranslation?.totalSale
                                      : "Total Sales"}
                                  </th>
                                </tr>
                              </thead>
                              {reports.length > 0
                                ? reports.map((report, index) => (
                                    <tbody>
                                      {loading ? (
                                        <td colSpan="8" className="py-5">
                                          <div style={{ textAlign: "center" }}>
                                            <i
                                              className="fas fa-spinner fa-pulse fa-2x"
                                              style={{ color: "green" }}
                                            ></i>
                                          </div>
                                        </td>
                                      ) : (
                                        <tr>
                                          <td> {report._id} </td>
                                          <td align="center">
                                            {report.orderCount}
                                          </td>
                                          <td align="center">
                                            {report.totalSales}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  ))
                                : ""}
                            </Table>
                          </div>
                        </Row>
                      </div>
                    </Card>
                  </Col>
                  <nav>
                    <Pagination>
                      <PaginationItem>
                        <PaginationLink
                          onClick={(e) => paginate(PageNo - 1)}
                          style={{ backgroundColor: "rgb(228, 231, 234)" }}
                        >
                          {reportingTranslation?.previousButton
                            ? reportingTranslation?.previousButton
                            : "Prev"}
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          onClick={(e) => paginate(PageNo + 1)}
                          style={{ backgroundColor: "rgb(228, 231, 234)" }}
                          className="mx-2"
                        >
                          {reportingTranslation?.nextButton
                            ? reportingTranslation?.nextButton
                            : "Next"}
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      ) : (
        <FreemiumPage text={fremiumText1} />
      )}
    </div>
  );
};

export default Reporting;
